import React, { useState } from 'react'

import { StyleSheet, Keyboard, Platform, ScrollView, View, Image, TouchableOpacity } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import client from '@sart/client'
import { useContent } from '@sart/content'
import { prettyErrorMessage, testID } from '@sart/utilities'
import { adaptive, backgroundColors, typography, colors } from '@sart/styles'
import AppConfig from '../Configuration'
import CameraComponent from '../Sign/CameraComponent'
import ApiClient from '../bff-client/src/ApiClient';
import CustomersApi from '../bff-client/src/api/CustomersApi';
import SubscriptionsApi from '../bff-client/src/api/SubscriptionsApi';
import OrdersApi from '../bff-client/src/api/OrdersApi';

import {
  Text,
  Title,
  Description,
  Space,
  Button,
  TextInputExtended,
  KeyboardAvoidingView,
  ReturnFooter,
  Anchor
} from '@sart/components'

import NeedHelpFooter from '../NeedHelpFooter'
import * as theme from '../Sign/signTheme'
import { Camera, CompanyIcon } from '@sart/icons'
import { Dimensions } from 'react-native'
import { min } from 'lodash'
import { number } from 'currency-codes'
import delay from 'delay'

export default function ActivateICCID(props) {
  const content = useContent()

  const { navigation, route } = props
  const email = route.params?.email

  const [scanning, setScanning] = useState(false)

  const bffClient = new ApiClient(AppConfig.bffBasePath)
  bffClient.defaultHeaders = {
    ...bffClient.defaultHeaders,
    Origin: AppConfig.shopOriginUrl
  }
  const customersApi = new CustomersApi(bffClient)
  const subscriptionsApi = new SubscriptionsApi(bffClient)

  let emailRef

  const formik = useFormik({
    initialValues: {
      number: '',
      email: ''
    },
    validationSchema: Yup.object().shape({
      number: Yup.string().trim().required(content.forms.required)
    }),
    onSubmit: handlePhoneRegistration,
  })

  function barCodeProcessed(data) {
    setScanning(false)
    if (data != undefined) {
      formik.setFieldValue('number', data.value.substring(data.value.length - 5, data.value.length))
      formik.setFieldTouched('number', true, false)
    }
  }

  async function handlePhoneRegistration(values, form) {
    Keyboard.dismiss()
    form.setSubmitting(true)
    try {
      if (values.number.length === 5) {
        values.number = AppConfig.iccidPrefix + values.number.trim()
      }

      const customersIdActivatePostRequest = {
        iccid: values.number,
      }

      //Need to add the token to the header for the activation
      bffClient.defaultHeaders['Authorization'] = `Bearer ${client.cache.token}`;

      console.log('activating customer with iccid: ', values.number)
      const activationResponse = await customersApi.customersIdActivatePost(client.cache.customerId, { customersIdActivatePostRequest })

      console.log('activationResponse is: ' + JSON.stringify(activationResponse, null, 2))

      /*
      {
        "basketRefId": "BRF-0001234",
        "gatewayURL": "https://checkout.stripe.com/pay/cs_test_..."
      }
      */

      const basketRefId = activationResponse?.basketRefId
      console.log('basketRefId is: ' + basketRefId)

      if (!basketRefId) {
        //order failed, throw an exception to be caught
        throw new Error(content.menu.activationFailed)
      }

      await delay(5000)

      //we need to remove the Authorization header from the bff client AND the ordersApi to be safe for the below api call
      bffClient.defaultHeaders['Authorization'] = undefined;
      const freshOrdersApi = new OrdersApi(bffClient)
      console.log('bff client default headers: ' + JSON.stringify(bffClient.defaultHeaders, null, 2))
      console.log('fresh orders client default headers: ' + JSON.stringify(freshOrdersApi.apiClient.defaultHeaders, null, 2))
      console.log('getting activation order with basket ref Id: ', basketRefId)
      let activationOrder = await freshOrdersApi.ordersGet(basketRefId)

      if (!activationOrder) {
        throw new Error(content.menu.activationFailed)
      }
      console.log('activationOrder is: ' + JSON.stringify(activationOrder, null, 2))

      if (activationOrder.status === "successful") {
        //Only update the BFF if we have an actual success message from the activation
        const activationBffResponse = await customersApi.customersSubscriptionsActivatePost({ email })
        //resync from the SSB after activation to hopefully sync the products straight through
        console.log('reloading dashboard data after ICCID activation')
        client.setCache({ refreshDashboardData: Date.now() })
        const params = { recentlyActivated: true }
        navigation.navigate('Overview', params)
      } else {
        throw new Error(content.menu.activationFailed)
      }


    } catch (error) {
      //undo the number change from before
      // values.number = values.number.replace(AppConfig.iccidPrefix, '')
      console.log('Error during activation:', JSON.stringify(error))
      form.setSubmitting(false)
      const message = prettyErrorMessage(error, 'registration', content)
      form.setFieldError('number', message)
    }
  }

  return (
    <View style={styles.container}>
      {!scanning &&
        // <ScrollView style={styles.scrollViewContainer}>
        <KeyboardAvoidingView style={styles.content}>
          <Space height={styles.spaceHeightOne.height} />
          <View style={styles.logo}>
            <Image
              source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
              //height={styles.logoStyle.height} width={200} alignSelf={"center"}
              style={styles.logoImage}
            />
            {/* <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={200} /> */}
          </View>
          <Title {...theme.title}>{content.activate_iccid.title}</Title>

          <Space height={styles.spaceHeightTwo.height} />
          <View style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
            <View style={{ flex: 1 }}>
              <TextInputExtended
                label={content.activate_iccid.iccidLabel}
                value={formik.values.number}
                placeholder={content.activate_iccid.iccidPlaceholder}
                keyboardType="phone-pad"
                onChangeText={formik.handleChange('number')}
                onBlur={formik.handleBlur('number')}
                error={formik.touched.number && formik.errors.number}
                style={styles.textInput}
                labelStyle={styles.labelStyle}
                onSubmitEditing={formik.handleSubmit}
                footerErrorContainerStyle={styles.errorContainer}
                {...testID('SignUpRegisterNumber')}
              />
            </View>
            <TouchableOpacity
              style={styles.camera}
              onPress={() => setScanning(true)}
            >
              <Camera onPress={() => setScanning(true)} color={colors.brightOrange} />
            </TouchableOpacity>
          </View>

          <Space height={24} />

          <Button
            title={
              formik.isSubmitting
                ? content.activate_iccid.inProgress
                : content.activate_iccid.action
            }
            disabled={!formik.isValid || formik.isSubmitting}
            onPress={formik.handleSubmit}
            {...theme.button}
            titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
            disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white + 45 }}
            {...testID('SignUpRegisterSubmit')}
          />
          <Space height={12} />

          {/* <Text style={styles.footerStyle}>{content.activate_iccid.note}</Text> */}

          {/* <Space height={24} /> */}
          {/* <ReturnFooter
            cancelStyle={styles.cancelStyle}
            title={content.common.cancel}
            onPress={() => navigation.goBack()}
          /> */}
        </KeyboardAvoidingView>
        // </ScrollView>
      }
      {scanning &&
        <CameraComponent
          barCodeProcessed={barCodeProcessed}
        />
      }
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
    minHeight: '100%',
    // height: Dimensions.get('window').height
    //alignItems: 'center'
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    })
  },
  scrollViewContainer: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
  },
  content: {
    flex: 1,
    ...adaptive.wrapperPadding,
    ...adaptive.logoPadding,
    backgroundColor: backgroundColors.darkCharcoal,
    // height: '100%',
    // paddingTop: 24,
    // ...adaptive.contentHeight,
    // height: Dimensions.get('window').height
    maxWidth: 600,
    width: '100%'
  },
  cancel: {
    justifyContent: 'center',
    alignItems: 'center',
    // padding: 24
  },
  logoStyle: {
    ...adaptive.guruSize
  },
  cancelStyle: {
    color: colors.white
  },
  footerStyle: {
    color: colors.white
  },
  spaceHeightOne: {
    ...adaptive.spaceHeightRegisterScreenOne
  },
  spaceHeightTwo: {
    ...adaptive.spaceHeightRegisterScreenTwo
  },
  spaceHeightThree: {
    ...adaptive.spaceHeightRegisterScreenThree
  },
  description: {
    textAlign: 'center',
    ...typography.demi,
    color: colors.srGreen
  },
  link: {
    color: colors.clear,
    fontSize: 14
  },
  logo: {
    alignSelf: "center"
  },
  text: {
    color: colors.srGreen,
    fontSize: 14
  },
  camera: {
    // position: 'absolute',
    // height: '100%',
    justifyContent: 'center',
    paddingLeft: '3%',
    paddingTop: '10%',
    maxWidth: 40,
    ...Platform.select({
      web: {
        marginTop: 'auto',
      },
      default: {
        marginTop: 8,
      }
    })
    // alignSelf: 'flex-end',
  },
  textInput: {
    color: colors.srTextInput,
    backgroundColor: backgroundColors.white,
    height: 48,
    borderRadius: 16,
    minWidth: 300,
    width: '100%'
  },
  labelStyle: {
    color: colors.brightOrange,
    ...typography.demi
  },
  logoImage: {
    height: 45,
    width: 45,
    position: 'relative',
    alignSelf: 'center',
    width: 200,
    ...adaptive.guruSize
  },
  errorContainer: {
    maxWidth: 320,
  }
})
